module.exports = __webpack_public_path__ + "img/Finsia.45dbb3f5.png";